module.exports = __webpack_public_path__ + "videos/quickshape-jp.df9d544.mp4";